function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/* eslint-disable no-unused-vars */
import { Component } from 'react';
import _ from 'underscore';
import { ReportQuery } from './query';
import Hit from './hit';
import HSP from './hsp';
import AlignmentExporter from './alignment_exporter';
/* eslint-enable no-unused-vars */
import { jsx as _jsx } from "react/jsx-runtime";
var Hits = /*#__PURE__*/function (_Component) {
  function Hits(props) {
    var _this;
    _classCallCheck(this, Hits);
    _this = _callSuper(this, Hits, [props]);
    _this.numUpdates = 0;
    _this.nextQuery = 0;
    _this.nextHit = 0;
    _this.nextHSP = 0;
    _this.maxHSPs = 10; // max HSPs to render in a cycle
    _this.state = props.state;
    _this.state.pluginResults = [];
    _this.prepareAlignmentOfSelectedHits = _this.prepareAlignmentOfSelectedHits.bind(_this);
    return _this;
  }
  _inherits(Hits, _Component);
  return _createClass(Hits, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.plugins.init(this.onPluginResultsFetched.bind(this));
      this.componentDidUpdate(this.props, this.state);
    }
  }, {
    key: "onPluginResultsFetched",
    value: function onPluginResultsFetched(pluginResults) {
      this.setState({
        pluginResults: pluginResults
      });
    }
  }, {
    key: "replacePluginResults",
    value: function replacePluginResults(pluginResults) {
      if (!pluginResults) return;
      var updatedResults = this.props.plugins.replacePluginResults(this.state.results, pluginResults);
      this.setState({
        results: updatedResults,
        pluginResults: pluginResults
      });
    }

    /**
    * Called for the first time after as BLAST results have been retrieved from
    * the server and added to this.state by fetchResults. Only summary overview
    * and circos would have been rendered at this point. At this stage we kick
    * start iteratively adding 1 HSP to the page every 25 milli-seconds.
    */
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(_prevProps, prevState) {
      var _this2 = this;
      // Log to console how long the last update take?
      // console.log((Date.now() - this.lastTimeStamp) / 1000);

      // Queue next update if we have not rendered all results yet.
      if (this.nextQuery < this.state.queries.length) {
        // setTimeout is used to clear call stack and space out
        // the updates giving the browser a chance to respond
        // to user interactions.
        setTimeout(function () {
          return _this2.updateState();
        }, 25);
      } else {
        this.props.componentFinishedUpdating();
      }
      if (this.state.pluginResults.length > 0 && prevState.pluginResults.length == 0) {
        this.replacePluginResults(this.state.pluginResults);
      }
    }
  }, {
    key: "isFirstUpdate",
    value: function isFirstUpdate() {
      return this.nextQuery == 0 && this.nextHit == 0 && this.nextHSP == 0;
    }

    /* eslint complexity: ["error", 6] */
    /* ---------------------
    * Push next slice of results to React for rendering.
    */
  }, {
    key: "updateState",
    value: function updateState() {
      var results = {
        items: [],
        numHSPsProcessed: 0
      };
      this.processQueries(results);

      // Push the components to react for rendering.
      this.numUpdates++;
      this.lastTimeStamp = Date.now();
      this.setState({
        results: this.state.results.concat(results.items),
        veryBig: this.numUpdates >= 250
      });
    }
  }, {
    key: "processQueries",
    value: function processQueries(results) {
      while (this.nextQuery < this.state.queries.length) {
        var query = this.state.queries[this.nextQuery];

        // We may see a query multiple times during rendering because only
        // 10 hsps are rendered in each cycle, but we want to create the
        // corresponding Query component only the first time we see it.
        if (this.nextHit == 0 && this.nextHSP == 0) {
          results.items.push(this.renderReportQuery(query));
          results.items.push(this.props.plugins.queryResult(query, this.state.pluginResults));
        }
        this.processHits(results, query);
        this.iterateLoops(['nextQuery', 'nextHit'], query.hits.length);
        if (results.numHSPsProcessed == this.maxHSPs) break;
      }
    }
  }, {
    key: "processHits",
    value: function processHits(results, query) {
      while (this.nextHit < query.hits.length) {
        var hit = query.hits[this.nextHit];
        // We may see a hit multiple times during rendering because only
        // 3 hsps are rendered in each cycle, but we want to create the
        // corresponding Hit component only the first time we see it.
        if (this.nextHSP == 0) results.items.push(this.renderHit(query, hit));
        this.processHSPS(results, query, hit);
        this.iterateLoops(['nextHit', 'nextHSP'], hit.hsps.length);
        if (results.numHSPsProcessed == this.maxHSPs) break;
      }
    }
  }, {
    key: "processHSPS",
    value: function processHSPS(results, query, hit) {
      while (this.nextHSP < hit.hsps.length) {
        // Get nextHSP and increment the counter.
        var hsp = hit.hsps[this.nextHSP++];
        results.items.push(this.renderHsp(query, hit, hsp));
        results.numHSPsProcessed++;
        if (results.numHSPsProcessed == this.maxHSPs) break;
      }
    }

    /*
    *  this function check if 2nd argument is reach end of it
    */
  }, {
    key: "iterateLoops",
    value: function iterateLoops(args, length) {
      if (this[args[1]] != length) return;
      this[args[0]]++;
      this[args[1]] = 0;
    }
  }, {
    key: "renderHsp",
    value: function renderHsp(query, hit, hsp) {
      return /*#__PURE__*/_jsx(HSP, _objectSpread({
        query: query,
        hit: hit,
        hsp: hsp,
        algorithm: this.state.program,
        showHSPNumbers: hit.hsps.length > 1
      }, this.props), 'Query_' + query.number + '_Hit_' + hit.number + '_HSP_' + hsp.number);
    }
  }, {
    key: "renderHit",
    value: function renderHit(query, hit) {
      return /*#__PURE__*/_jsx(Hit, _objectSpread({
        query: query,
        hit: hit,
        algorithm: this.state.program,
        querydb: this.state.querydb,
        selectHit: this.selectHit,
        imported_xml: this.state.imported_xml,
        non_parse_seqids: this.state.non_parse_seqids,
        showQueryCrumbs: this.state.queries.length > 1,
        showHitCrumbs: query.hits.length > 1,
        veryBig: this.state.veryBig,
        onChange: this.prepareAlignmentOfSelectedHits
      }, this.props), 'Query_' + query.number + '_Hit_' + hit.number);
    }
  }, {
    key: "renderReportQuery",
    value: function renderReportQuery(query) {
      return /*#__PURE__*/_jsx(ReportQuery, {
        query: query,
        program: this.state.program,
        querydb: this.state.querydb,
        showQueryCrumbs: this.state.queries.length > 1,
        non_parse_seqids: this.state.non_parse_seqids,
        imported_xml: this.state.imported_xml,
        veryBig: this.state.veryBig
      }, 'Query_' + query.id);
    }

    /* eslint complexity: ["error", 6] */
    /* -----------------------------------
    * Event-handler when hit is selected
    * Adds border-seqorange to hit component.
    * Updates number of Fasta that can be downloaded
    */
  }, {
    key: "selectHit",
    value: function selectHit(id) {
      var checkbox = $('#' + id);
      var num_checked = $('.hit-links :checkbox:checked').length;
      if (!checkbox || !checkbox.val()) return;
      var $hit = $(checkbox.data('target'));

      // Highlight selected hit and enable 'Download FASTA/Alignment of
      // selected' links.
      if (checkbox.is(':checked')) {
        $hit.addClass('border-seqorange');
        $hit.next('.hsp').addClass('border-seqorange');
        $hit.removeClass('border-transparent');
        $hit.next('.hsp').removeClass('border-transparent');
        $('.download-fasta-of-selected').enable();
        $('.download-alignment-of-selected').enable();
      } else {
        $hit.removeClass('border-seqorange');
        $hit.next('.hsp').removeClass('border-seqorange');
        $hit.addClass('border-transparent');
        $hit.next('.hsp').addClass('border-transparent');
        $('.download-fasta-of-selected').attr('href', '#').removeAttr('download');
      }
      var $a = $('.download-fasta-of-selected');
      var $b = $('.download-alignment-of-selected');
      if (num_checked >= 1) {
        $a.find('.font-bold').html(num_checked);
        $b.find('.font-bold').html(num_checked);
        $a.find('.font-bold').addClass('px-1').removeClass('px-0.5');
        $b.find('.font-bold').addClass('px-1').removeClass('px-0.5');
      }
      if (num_checked == 0) {
        $a.addClass('disabled').find('.font-bold').html('');
        $b.addClass('disabled').find('.font-bold').html('');
        $a.find('.font-bold').removeClass('px-1').addClass('px-0.5');
        $b.find('.font-bold').removeClass('px-1').addClass('px-0.5');
      }
    }
  }, {
    key: "prepareAlignmentOfSelectedHits",
    value: function prepareAlignmentOfSelectedHits() {
      var sequence_ids = $('.hit-links :checkbox:checked').map(function () {
        return this.value;
      }).get();
      if (!sequence_ids.length) {
        // remove attributes from link if sequence_ids array is empty
        $('.download-alignment-of-selected').attr('href', '#').removeAttr('download');
        return;
      }
      if (this.state.alignment_blob_url) {
        // always revoke existing url if any because this method will always create a new url
        window.URL.revokeObjectURL(this.state.alignment_blob_url);
      }
      var hsps_arr = [];
      var aln_exporter = new AlignmentExporter();
      var self = this;
      _.each(this.state.queries, _.bind(function (query) {
        _.each(query.hits, function (hit) {
          if (_.indexOf(sequence_ids, hit.id) != -1) {
            hsps_arr = hsps_arr.concat(self.props.populate_hsp_array(hit, query.id));
          }
        });
      }, this));
      var filename = 'alignment-' + sequence_ids.length + '_hits.txt';
      var blob_url = aln_exporter.prepare_alignments_for_export(hsps_arr, filename);
      // set required download attributes for link
      $('.download-alignment-of-selected').attr('href', blob_url).attr('download', filename);
      // track new url for future removal
      this.setState({
        alignment_blob_url: blob_url
      });
    }
  }, {
    key: "render",
    value: function render() {
      return this.state.results;
    }
  }]);
}(Component);
export default Hits;